<template>
	<div id="qs_index">
		<dv-full-screen-container class="bg bg-video">
			<div v-on:click="screen()"><dv-decoration-9 :color="['#55ffff', '#0090ff']"
					class="full_screen">{{ screenName }}</dv-decoration-9></div>
			<video autoplayloopposter="polina.jpg" class="bgvid" id="bgvid" autoplay muted loop>
				<source src="../../assets/img/qualitySchBg.mp4" type="video/mp4">
			</video>
			<dv-loading v-if="loading">Loading...</dv-loading>
			<div v-else class="host-body">
				<!-- 第一行标题装饰条 -->
				<div class="d-flex jc-center">
					<dv-decoration-10 :color="['#572dcd', '#0090ff']" style="width:10%;height:.0625rem;" />
					<div class="d-flex jc-center" style="width:80%;">
						<dv-decoration-8 :color="['#0090ff', '#0d1342']" style="width:15%;height:.625rem;" />
						<div class="title" style="width:70%;">
							<span class="title-text">{{ title }}</span>
						</div>
						<dv-decoration-8 :reverse="true" :color="['#0090ff', '#0d1342']"
							style="width:15%;height:.625rem;" />
					</div>
					<dv-decoration-10 :color="['#572dcd', '#0090ff']"
						style="width:10%;height:.0625rem;transform: rotateY(180deg);" />
				</div>
				<div class="body-box">
					<!-- 第三行数据开始 -->
					<div class="w-100 content-box">
						<div class="main_grid">
							<!-- 第一列 -->
							<div>
								<!-- 2小块数据 -->
								<div class="w-100 d-flex flex-nowrap flex-between" style="margin: 0.1rem 0;">
									<div class="small_block" style="margin-top:-16px;height: 200px;">
										<dv-border-box-4 :color="['#0575e6', '#00f260']">
											<div class="cc-header">
												<div class="active_title">基本信息</div>
											</div>
											<div class="topl_block1">
												<div class="float-l">
													<div class="float-l">
														<div class="fw-b block_num" style="color:#ff8142;">{{ studentNum }}
														</div>
														<div class="title-item">学生人数</div>
													</div>
												</div>
												<div class="float-r">
													<div class="float-l">
														<div class="fw-b block_num" style="color:#00f260;">{{ teacherNum }}
														</div>
														<div class="title-item">教师人数</div>
													</div>
												</div>
											</div>
											<dv-decoration-1 style="width:80%;height:0.3rem;margin: 0 auto;" />
										</dv-border-box-4>
									</div>
									<div style="width: 1px;margin: 35px 0 40px 0;background: #0d4b97;"></div>
									<div class="small_block" style="height: 200px;">
										<dv-border-box-4 :color="['#0575e6', '#00f260']" :reverse="true">
											<div class="topl_block2">
												<ul>
													<li>
														<span class="float-l">昨日完成评价</span>
														<span class="float-r"><b class="colorbluegreen">{{ dayNum }}</b>
															条</span>
													</li>
													<dv-decoration-2 style="width:100%;height:3px;" />
													<li>
														<span class="float-l">本周完成评价</span>
														<span class="float-r"><b class="colorOrange">{{ weekNum }}</b>
															条</span>
													</li>
													<dv-decoration-2 style="width:100%;height:3px;" />
													<li>
														<span class="float-l">本月完成评价</span>
														<span class="float-r"><b class="colorBlue">{{ monthNum }}</b> 条</span>
													</li>
													<dv-decoration-2 style="width:100%;height:3px;" />
												</ul>
											</div>
										</dv-border-box-4>
									</div>
								</div>
								<!-- 第二行数据 -->
								<div class="w-100 d-flex flex-nowrap flex-between" style="margin: 0.1rem 0;">
									<div class="l_block">
										<dv-border-box-13 :color="['#0575e6', '#00f260']">
											<left1 />
										</dv-border-box-13>
									</div>
									<div class="l_block">
										<dv-border-box-13 :color="['#0575e6', '#00f260']">
											<left2 />
										</dv-border-box-13>
									</div>
								</div>
							</div>
							<!-- 第一列结束 -->
							<!-- 第二列 -->
							<div>
								<!-- 上半部分 -->
								<div class="mt_map">
									<dv-border-box-1 :color="['#0575e6', '#00f260']">
										<center1 />
									</dv-border-box-1>
								</div>
								<!-- 下半部分 -->
								<div class="center_btm">
									<!-- 老师评价工作 -->
									<dv-border-box-6 :color="['#0575e6', '#00f260']">
										<center2 />
									</dv-border-box-6>
								</div>
								<!-- 下半部分结束 -->
							</div>
							<!-- 第二列结束 -->
							<!-- 第三列开始 -->
							<div>
								<!-- 1 -->
								<div class="r_block">
									<dv-border-box-8 :color="['#0575e6', '#00f260']">
										<right1 />
									</dv-border-box-8>
								</div>
								<!-- 2 -->
								<div class="r_block">
									<dv-border-box-8 :color="['#0575e6', '#00f260']">
										<right2 />
									</dv-border-box-8>
								</div>
							</div>
							<!-- 第三列结束 -->
						</div>
					</div>
					<!-- 第三行数据结束 -->
				</div>

			</div>
		</dv-full-screen-container>
	</div>
</template>

<script>
var storage = window.localStorage;
var orgCode = storage.getItem("orgCode");
var source = storage.getItem("source");
var schoolName = storage.getItem("schoolName");
var title = storage.getItem("title");
if (title == 'false') {
	title = schoolName + '综合素质评价大数据看板';
}
console.log("index:" + orgCode);
import left1 from "./left1";
import left2 from "./left2";
import right1 from "./right1";
import right2 from "./right2";
import center1 from "./center1";
import center2 from "./center2";
export default {
	data() {
		return {
			loading: true,
			title: title,
			studentNum: 0,
			teacherNum: 0,
			dayNum: 0,
			weekNum: 0,
			monthNum: 0,
			fullscreen: false,
			screenName: "全屏"
		};
	},
	components: {
		left1,
		left2,
		right1,
		right2,
		center1,
		center2
	},
	mounted() {
		this.cancelLoading();
		this.initData();
		// 定时刷新时间
		let _this = this;
		// 定时器
		this.interval1 = setInterval(() => {
			_this.date = _this.dateFormatToString(new Date()); // 修改数据date
		}, 1000);
		// 定时器刷新，1天
		this.interval2 = setInterval(() => {
			_this.initData();
		}, 1000 * 60 * 60 * 24);
	},
	beforeDestroy() {
		clearInterval(this.interval1);
		clearInterval(this.interval2);
	},
	methods: {
		//关闭loading加载条
		cancelLoading() {
			setTimeout(() => {
				this.loading = false;
			}, 1000);
		},
		initData() {
			let _this = this;
			//判断访问客户端类型
			if (source == 'window') {
				_this.screenName = "全屏";
			} else {
				_this.screenName = "返回";
			}
			this.$http.get("/dataView/quality/getEvalPeopleNum?orgCode=" + orgCode).then(res => {
				if (res.data.code === 200) {
					var result = res.data.result;
					_this.studentNum = result.stuCount;
					_this.teacherNum = result.teaCount;
					_this.dayNum = result.dayCount;
					_this.weekNum = result.weekCount;
					_this.monthNum = result.monthCount;
				}
			});
		},
		//点击全屏
		screen: function () {
			//判断访问客户端类型
			if (source == 'window') {
				let _this = this;
				let element = document.documentElement;
				if (_this.fullscreen) {
					if (document.exitFullscreen) {
						document.exitFullscreen();
					} else if (document.webkitCancelFullScreen) {
						document.webkitCancelFullScreen();
					} else if (document.mozCancelFullScreen) {
						document.mozCancelFullScreen();
					} else if (document.msExitFullscreen) {
						document.msExitFullscreen();
					}
					_this.screenName = "全屏";
				} else {
					if (element.requestFullscreen) {
						element.requestFullscreen();
					} else if (element.webkitRequestFullScreen) {
						element.webkitRequestFullScreen();
					} else if (element.mozRequestFullScreen) {
						element.mozRequestFullScreen();
					} else if (element.msRequestFullscreen) {
						element.msRequestFullscreen();
					}
					_this.screenName = "取消";
				}
				_this.fullscreen = !_this.fullscreen;
			} else {
				//window.AndroidWebView.finish();
				this.$router.replace('/dataView/appIndex/school?orgCode=' + orgCode);
			}
		}
	}
};
</script>

<style lang="scss">
@import "../../assets/scss/qsIndex.scss";

#qs_index {

	.small_block {
		width: 49%;

		.cc-header {
			width: 100%;
			text-align: right;

			.active_title {
				font-size: 0.3rem;
				padding-right: 0.2rem;
				color: #55ffff;
				text-align: left;
				padding-top: 20px;
				padding-left: 45px;
			}
		}

	}

	.small_block dv-border-box-8 {
		width: 100%
	}

	.topl_block1 {
		text-align: center;
		font-size: 0.25rem;
		color: #d3d6ff;
		padding: 0.3rem 1rem 0.22rem 0.8rem;
		overflow: hidden;
	}

	.topl_block1 .block_num {
		font-size: 0.35rem;
		color: #55ffff;
	}

	.topl_block2 {
		padding: 0.5rem;
	}

	.topl_block2 li {
		color: #d3d6ff;
		overflow: hidden;
		padding: 0.03rem;
		font-size: 0.2rem;
	}

	.topl_block2 li .float-l {
		display: inline-block;
		line-height: 0.4rem;
	}

	.topl_block2 li b {
		font-size: 0.35rem;
	}

	.r_block {
		margin: 0.15rem 0;
		height: 44.3vh;
	}

	.l_block {
		width: 49%;
		margin: 0.1rem 0;
		height: 70.5vh;
	}

	.mt_map {
		height: 59vh;
		margin: 0.12rem 0.1rem 0.15rem 0.1rem;
	}

	.center_btm {
		height: 30vh;
		margin: 0 0.1rem;
	}

	.title {
		line-height: 0.8rem;

		.title-text {
			font-size: 0.45rem !important;
			width: 100%;
			font-weight: 600;
			background-image: linear-gradient(135deg, #00c3d4, #7243e1);
			-webkit-background-clip: text;
			color: transparent;
		}
	}
}</style>
